module.exports = __webpack_public_path__ + "img/daphne_nt.7ace253a.png";